import { render } from "./StepBanner.vue?vue&type=template&id=343a2118&scoped=true"
import script from "./StepBanner.vue?vue&type=script&lang=ts"
export * from "./StepBanner.vue?vue&type=script&lang=ts"

import "./StepBanner.vue?vue&type=style&index=0&id=343a2118&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-343a2118"

export default script